import { gql } from '@apollo/client';

const UPLOAD_DOCUMENT_MUTATION = gql`
  mutation UploadDocument($ownerId: String!, $documentName: String!, $documentType: String!) {
    uploadDocument(documentData: { ownerId: $ownerId, name: $documentName, type: $documentType }) {
      document {
        name
        id
        uploaded
        ownerId
        type
        url
      }
    }
  }
`;

const DELETE_DOCUMENT_MUTATION = gql`
  mutation DeleteDocument($documentId: UUID!) {
    deleteDocument(data: { id: $documentId }) {
      success
      message
    }
  }
`;

export const documentUploadMutations = {
  UPLOAD_DOCUMENT_MUTATION,
  DELETE_DOCUMENT_MUTATION,
};
